import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=475d80cc"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports